import { H2, H4, H5, Paragraph } from '@daren/ui-components'
import { CheckIcon, UsersIcon } from '@heroicons/react/solid'
import * as React from 'react'

import { ButtonLink } from '../buttons'

import { useTranslations } from '~/context/translations-provider'

import type { Pricing } from '~/types'

function PricingCard({
  title,
  price,
  duoPrice,
  description,
  popular,
  included,
}: Pricing) {
  const { t } = useTranslations()

  return (
    <div className="relative p-12 h-full bg-white rounded-xl border border-secondary">
      {popular && (
        <div className="absolute top-0 left-8 p-2 mt-0 text-xs text-white bg-accent rounded-full -translate-y-1/2">
          <span className="font-sans font-bold">{t('pricing-popular')}</span>
        </div>
      )}
      <div className="flex flex-col justify-between h-full">
        <div className="space-y-6">
          <div className="pb-6 space-y-8 border-b border-secondary">
            <H4 as="h2">{title}</H4>
            <div>
              <H2 as="h3" className="font-sans font-black">
                {`€ ${price}`}
              </H2>
              {duoPrice && (
                <H5
                  as="h3"
                  className="flex items-center mt-2 space-x-4 font-sans font-normal"
                >
                  <span title="duo's">
                    <UsersIcon className="w-5 h-5 text-accent" />
                    <span className="sr-only">duo&apos;s</span>
                  </span>
                  <span>{`€ ${duoPrice}`}</span>
                </H5>
              )}
            </div>
            <Paragraph textColorClassName="text-secondary">
              {description}
            </Paragraph>
          </div>
          <ul className="space-y-4">
            {included?.map(feature => (
              <li key={feature} className="flex items-center">
                <CheckIcon className="w-5 h-5 text-accent" />
                <span className="ml-3 text-base font-medium">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
        <ButtonLink href="/nl/contact" className="mt-16 w-full">
          {t('pricing-contact-us')}
        </ButtonLink>
      </div>
    </div>
  )
}

function PricingTable({ items }: { items: Pricing[] }) {
  return (
    <div className="flex flex-col justify-center items-center mt-16 space-y-8 xl:flex-row xl:items-stretch xl:space-y-0 xl:space-x-8">
      {items.map(item => (
        <section
          key={item._key}
          className="flex flex-col space-y-6 w-full max-w-sm"
        >
          <PricingCard {...item} />
        </section>
      ))}
    </div>
  )
}

export { PricingTable }
